@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

.ciTemplate {
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  border: 10px solid white;
  background-size: contain;
  background-position: right center;
  background-repeat: no-repeat;
  background-color: #ededed;
  @include image('assets/header/inspiration-2x.jpg');

  &-text-content {
    width: 45%;
    height: 100%;
    padding: 25px 50px 50px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    box-sizing: border-box;
  }

  &-subHeading {
    padding-bottom: 28px;
  }
}
